export const CUSTOM_DAYPART_ID = {
  tvId: 35,
  radioId: 36,
};
